import type { ScrollState } from '@atlassian/jira-software-deployments-common-table/src/utils';

type Pixels = number;

export const getScrollAmountForSidebarClosing = (
	scrollState: ScrollState,
	sidebarWidth: Pixels,
): Pixels => {
	const { scrollWidth, scrollLeft, clientWidth } = scrollState;
	const distanceToRightEdge = scrollWidth - scrollLeft - clientWidth;

	// When the sidebar is closing, we need to scroll right to "undo" what we did when
	// it opened. There's an edge-case though: when the scroll distance to the right edge
	// is less than the width of the sidebar, scrolling by the full sidebar width would
	// scroll too far.
	if (distanceToRightEdge < sidebarWidth) {
		return -distanceToRightEdge;
	}
	return -sidebarWidth;
};
